const getAmountBoughtProducts = (state) => state.boughtProducts.getBoughtProducts.length;
const getBoughtProducts = (state) => state.boughtProducts.getBoughtProducts;

export {getAmountBoughtProducts, getBoughtProducts};